import { FunctionComponent, useState } from "react";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import LoadingWidget from "../../../ui/pages/content_panel/ui/new_components/common/loading_spinner";
import StadiumButton from "../../../ui/new_components/common/stadium_button";
import {
  GetPurchaseServiceVoucherExportDataByMail,
  GetPurchaseVoucherExportDataByMail,
} from "./repo/purchase_voucher_repo";

interface ExportGRNProps {
  filter: {
    all: boolean;
    count: number;
    total?: number;
    page: number;
    toDate?: Date;
    fromDate?: Date;
    delivery_from?: Date;
    delivery_to?: Date;
    gr_number?: string;
    srn_number?: string;
    po_number?: string;
    selectedVendors?: string[];
    selectedWarehouses?: string[];
  };
  type?: "GRN" | "SRN";
  onClose: () => void;
}

const ExportGRN: FunctionComponent<ExportGRNProps> = (props) => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const getPODetailedListData = async () => {
    const filter = props.filter;
    setLoading(true);
    try {
      const searchProp = { ...filter };
      searchProp.all = true;
      const response =
        props.type === "SRN"
          ? await GetPurchaseServiceVoucherExportDataByMail(searchProp)
          : await GetPurchaseVoucherExportDataByMail(searchProp);
      if (response.success) {
        showToast({
          type: ToastType.success,
          text: response.message,
        });

        props.onClose();
      } else {
        showToast({
          type: ToastType.error,
          text: response.message,
        });
      }

      setLoading(false);
    } catch (error: any) {
      console.error("Export initiation error:", error);

      showToast({ type: ToastType.error, text: error.error });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-5">
      <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center my-4">
        <StadiumButton type="button" onTap={getPODetailedListData}>
          Detailed Export
        </StadiumButton>
      </div>

      <LoadingWidget loading={loading} />
    </div>
  );
};

export default ExportGRN;
